import api from '../api';

const BASE_URL = '/api/v2/recplay-segment-templates';

const RecplaySegmentTemplatesAPI = {
	getRecplayTemplates: ({ pageNumber, pageSize, name, programId }) =>
		api.get(BASE_URL, {
			params: {
				pageNumber,
				pageSize,
				name,
				programId,
			},
		}),
};

export default RecplaySegmentTemplatesAPI;
